export const accountClaim = {
  welcomeTitle: "Welcome to Fullscript",
  welcomeSubtitle: "Create a password to get started.",
  setPasswordLabel: "Set a password",
  passwordCaption: "Min. 8 characters",
  passwordTooShort: "Must be at least 8 characters long",
  confirmPasswordLabel: "Confirm password",
  confirmPasswordMismatch: "Passwords must match",
  remindersCheckboxLabel: "Text me reminders and offers (optional)",
  phoneNumberLabel: "Phone number",
  smsDisclaimer:
    "By consenting to receive texts from Fullscript at the number provided, you may receive messages including autoreminders. Consent isn't required as a condition to purchase. Reply STOP to cancel; if you subscribe to more than one program, opting out of one won't cancel all of them. Message and data rates may apply. See Fullscript's <tos>Terms of Service</tos> and <privacy>Privacy Statement</privacy> for more information.",
  continueButton: "Continue",
  orDivider: "OR",
  tosRequiredForContinue: "Accept terms of service and privacy statement to proceed.",
  submitError: "Something went wrong. Please try again.",
} as const;
